import React, { createContext, useCallback, useEffect, useRef, useState } from 'react'
import DrillThru from '../DrillThru/DrillThru'
import { FoundationsEnums } from '../../enum'
import { TargetRubric } from '../TargetRubric/TargetRubric'
import { getDrillThruPayload, IDrillThruPayloadState } from '../../Redux/DrillThru/DrillThruSlice'
import { useGetBusinessParametersMutation } from "../../Redux/VisualUnits/vuParamSlice";
import { useDispatch, useSelector } from 'react-redux'
import { SummaryGauge } from './Gauge'
import { getBaseUrl } from '../../Utils'
import { getToolTipContent } from '../Reports/ReportTooltip'
import DetailedTooltip from '../../GenericComponents/Tooltip/DetailedTooltip'
import {
    IVUconfigResponse,
    useExecuteTableMutation,
    useExecuteVUMutation,
    useMarkVUFavouriteMutation,
    useSubmitFormMutation,
} from '../../Redux/VisualUnits/visualUnitAPISlice'
import {
    ChartConfig,
    getEditSetVUInitPayload,
    getReportActionsState,
    getVuObjInfoState,
    getVUParamsInfoState,
    IActionsOpenState,
    IRunVuPayloadState,
    IVUDataObj,
    setReportActionsState,
    SetVudata,
} from '../../Redux/VisualUnits/visualUnitStateSlice'
import Dialog from '../../GenericComponents/dialog'
import {
    useCheckEditSaveMutation,
    useEditSaveVUMutation,
    useFetchExecutePayloadMutation,
} from '../../Redux/ReportActions/reportActionsSlice'
import DashboardVUParams from '../Reports/DashboardVuParams'
import { selectTriggerState } from '../../Redux/TriggerApi/triggerApiSlice'
import { postVUobj } from '../../Redux/VisualUnits/gaugeSlice'
import { VuSettings } from '../Reports/VuSettings'
import { getCurrentUserData, RootState } from '../../Redux/store'
import { FoundationsConstants } from '../../FoundationsConstants'
import ReportEl, { ReportProps } from '../Reports/Report'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import ReportActions from '../Reports/ReportActions'
import { ITableDrillThru } from '../Reports/ReportFrame'
import { markVisualUnitFavorite } from '../../Pages/Workspace/workspace'
import { getWorkspaceData } from '../../Redux/Workspace/workspaceSlice'
import LoaderBox from '../../GenericComponents/LoaderBox'
import { getMeasureListForVUID, isChart, isSummary, isTable } from '../../VisualunitHelpers'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { onEnter } from '../../GlobalMethods'
import { useZustandVisualUnitStore } from '../Reports/vuContext'
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace'
import { useWorkspaceStore } from '../../Pages/Workspace/workspaceContext'
import { VUSettingsDialog } from '../Reports/VUSettingsDialog'
declare let window: any
interface IVUObject {
    drillThruDpList: any[]
    vuDetails: VisualUnitApiDTO_VisualUnit
    execTableRespData: any
}
const UnicornApp = window.unicornInstance as any

export const SummaryReportContext = createContext<any>(null)

function IndividualSummary(props: { vuDetails:VisualUnitApiDTO_VisualUnit_Extended; actionType: string; setVuData: any; DashBoardId: number; setremoveFromWorkspace: ({ flag, id }: { flag: boolean; id: number }) => void }) {
    const vuDetails = props.vuDetails
    const actionType = props.actionType
    const dispatch = useDispatch()
    const [activeMeasure, setActiveMeasure] = useState<number>(-1)    
    const VUdataObjRef = useRef<IVUObject>({
        drillThruDpList: [],
        vuDetails: {} as VisualUnitApiDTO_VisualUnit,
        execTableRespData: {},
    })
    const [editing, setEditing] = useState(false)
    const [refreshReport, Setrefreshreport] = useState(0)
    // const [isSummaryEdit, setIsSummaryEdit] = useState(false)
    const [isExplore, setIsExplore] = useState(vuDetails.callerType == "Explore")
    const [noExecute, setNoExecute] = useState(false)
    const [executepayload] = useFetchExecutePayloadMutation()
    const initialDrillThruPayload = useSelector(getDrillThruPayload) //keep this
    const [callExecuteAPI, { data: executeResponse, error, isLoading }] = useExecuteVUMutation()
    const [execTableRespData, setExecTableRespData] = useState<any>({})
    const triggerApiState = useSelector(selectTriggerState)[vuDetails.VisualUnitId]
    const [callExecuteTableAPI, { data: executeTableResp }] = useExecuteTableMutation()
    const [hasError, sethasError] = useState(false)
    const [measureName, setMeasureName] = useState<string>('')
    const [columnClasses, setcolumnClasses] = useState<string[]>([])
    const [visualUnitId, setVisualUnitId] = useState(vuDetails.VisualUnitId)
    const [measureObjects, setMeasureObjects] = useState([] as { [s: string]: any }[])
    const [vu, setVu] = useState<any>(vuDetails) // need to convert into const var;
    const [tempData, setTempData] = useState({
        tempChartSwitch: vuDetails.ChartSwitch,
        tempChartSettings: vuDetails.ChartSettings,
        tempTableSettings: vuDetails.TableSettings,
        vuTempId: -1,
        tempViewerType: vuDetails.ViewerType,
        buildQuery: false,
        applyChange: false,
    })
    const [redrawReport, setRedrawReport] = useState(false)
    const [reportname, setreportName] = useState(vuDetails.Name)
    const [tableJSOnData, setTableJSOnData] = useState({} as any)
    const [drillThruPayload, setDrillThruPayload] = useState<ITableDrillThru>({
        initialPayload: null,
        actionMode: 'dt_paginate',
        hasError: false,
        modelData: null,
        inline: true,
        isAutoRefresh: false,
        measureIndex: 0,
        isDrillThruAllowed: true,
        measureVal: undefined,
        dataExplore: null,
        autoRefreshInterval: 0,
        data_is_summary: false,
        inlineParentNode: null,
        ishelprequest: false,
        vuDataObj: null,
        engineType: 'new_engine',
        __this: null,
        ViewerType: null,
    })

    const setupVU = useZustandVisualUnitStore((s) => s.setupVU);
    const zustand_vuState = useZustandVisualUnitStore((s) => s.vuState);
    
    const isUpdateFromSettings = useRef(false);
    const isSaveClicked = useRef(false);

    const memoizedTableJSONData = React.useMemo(() => {
        return execTableRespData?.reportData ? JSON.parse(execTableRespData.reportData) : null
    }, [execTableRespData.reportData])

    const [currenClickedMeausre, setcurrenClickedMeausre] = useState(-1)
    const [isOpenDrillThru, setIsOpenDrillThru] = useState<boolean>(false)
    const [launchExploreDrillThru, setLaunchExploreDrillThru] = useState<boolean>(false)
    const [targetMeasureList, setTargetMeasureList] = useState(vuDetails.MeasureList
        .map((measure: any, index: number) => ({
            ...measure,
            indexid: index,
        }))
        .filter(
            (measure: any) =>
                measure.UserTarget.TargetType != 0 ||
                measure.DefaultTarget.TargetType != 0
        )) // Assuming TargetMeasureList is imported or passed as a prop
    const [noTargetMeasureList, setNoTargetMeasureList] = useState(vuDetails.MeasureList
        .map((measure: any, index: number) => ({
            ...measure,
            indexid: index,
        }))
        .filter(
            (measure: any) =>
                measure.UserTarget.TargetType == 0 &&
                measure.DefaultTarget.TargetType == 0
        )) // Assuming NoTargetMeasureList is imported or passed as a prop
    const [targetlessMeasuresExist, setTargetlessMeasuresExist] = useState(vuDetails.MeasureList.some(
        (measure: any) =>
            measure.UserTarget.TargetType == 0 &&
            measure.DefaultTarget.TargetType == 0
    )) // temporary stuff
    // const [privacyLockText, setPrivacyLockText] = useState(
    //   UnicornConstants.PrivacyLockText[UnicornConstants.PrivacyLock[model.get('PrivacyLock')]]
    // );
    const [rendercomp, setrendercomp] = useState(false)
    const [showWorklist, setShowWorklist] = useState(false) // Assuming isWorklistOpen and checkIfDrillThruAllowed are functions
    const [longErrorMessage, setLongErrorMessage] = useState(false)
    const [errorText, setErrorText] = useState()
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))
    const isAdmin = ['FoundationsSystemAdmin', 'SystemAdmin'].indexOf(currentUserData.type) > -1
    // const [isAdmin, setIsAdmin] = useState(
    //     UnicornApp.isUserType(['FoundationsSystemAdmin', 'SystemAdmin'])
    // )
    const [exploreDrilThruPayload, setExploreDrilThruPayload] = useState<IDrillThruPayloadState | {}>({})

    const getWorkspaceIdFromStore = useSelector(getWorkspaceData)?.data.WorkspaceId
    const [showKmi, setshowKmi] = useState(false)
    //VU Settings Use States and data settings
    const [iseditSettingsDialogOpen, setiseditSettingsDialogOpen] = useState(false)
    const [isSummaryDrillThruLoading, setIsSummaryDrillThruLoading] = useState(false)
    const [toggleExpColDrillThru, settoggleExpColDrillThru] = useState(false)
    const [isVisible, setIsVisible] = useState(true)
    const [reportPrivacy, setreportPrivacy] = useState<0 | 1>(0)
    const [addedToFavourite, setaddedToFavourite] = useState(false)
    const vuObjDataInfoFromStore = useSelector(getVuObjInfoState)
    const vuObjParamsFromStore = useSelector(getVUParamsInfoState)
    const [vuParams, setVuParams] = useState(vuObjParamsFromStore)
    const [drillThruDPList, setDrillThruDPList] = useState<any[]>([])
    const [tempVuData, setTempVuData] = useState({
        ...vuDetails
    } as VisualUnitApiDTO_VisualUnit_Extended)

    const [operationStatusMessage, setOperationStatusMessage] = useState('')
    const [reportFailed, setReportFailed] = useState(false)

    // Name editing states and functions
    const [editingName, setEditingName] = useState(false);
    const [tempEditName, setTempEditName] = useState("");
    const [callEditSaveVUAPI] = useEditSaveVUMutation()
    const [vuObj, setVuObj] = useState(vuObjDataInfoFromStore)
    const [saveVUdataChanges, setsaveVUdataChanges] = useState<boolean>(false)
    const [shouldcallCheckeditsave, setshouldcallCheckeditsave] = useState<boolean>(false)
    const [CheckEditSaveResponse, setCheckEditSaveResponse] = useState<any>(null)
    const [usersUsingVUs, setusersUsingVUs] = useState(0)
    const [dashBoardsUsingVUs, setdashBoardsUsingVUs] = useState(0)
    const [roleNames, setRoleNames] = useState<string[]>([])

    const [BusinessParamsList, setBusinessparameterList] = useState<any>([])
    const [callGetBusinessParams] = useGetBusinessParametersMutation()

    // Initialize state
    useEffect(() => {
        setupVU(vuDetails);
    }, [vuDetails]);

    const updateTempVuData = (key: keyof VisualUnitApiDTO_VisualUnit, value: any) => {
        setTempVuData({ ...tempVuData, [key]: value })
    }
    const [callMarkVUfavouriteAPI] = useMarkVUFavouriteMutation()
    
    const closeKMI = () => {
        setshowKmi(false)
    }    

    const reportListRef = useRef<HTMLDivElement[]>([]);

    const setReportRef = useCallback((el: HTMLDivElement | null) => {
        if (el && !reportListRef.current.includes(el)) {
            reportListRef.current.push(el);
        }
    }, []);// FP-11689 Code for scrolling to the last report when copyVU is clicked

    const handleLoadComplete = (status: boolean) => {
        setIsSummaryDrillThruLoading(status)
    }
    const getFirstAllowedDrillThruIndex = () => {
        let index: number = 0
        if (executeResponse?.data.vuDetails.MeasureList) {
            for (let i = 0; i < executeResponse?.data.vuDetails.MeasureList.length; i++) {
                if (executeResponse?.data.vuDetails.MeasureList[i].AllowDrillThru !== 'Y') {
                    index++
                } else {
                    break
                }
            }
        }
        if (index >= executeResponse?.data.vuDetails.MeasureList.length) {
            index = -1
        }
        return index
    }

    const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);
    const bulkUpdateVUs = useWorkspaceStore((s) => s.updateVisualUnits);
    

// editName
const handleUpdateVUName = () => {
    const hasChanged = tempEditName !== tempVuData.Name;

    if (hasChanged) {
        const measureFilterList = getMeasureListForVUID(
            tempVuData.VisualUnitId,
            vuObjDataInfoFromStore,
            vuObjParamsFromStore,
            vuObj,
            tempVuData.MeasureList,
            setVuObj,
            tempVuData
        );
        const currentlist = measureFilterList.filter(
            (item: any) => item.id === tempVuData.VisualUnitId
        );
        const reqVisualUnitData = {
            id: tempVuData.VisualUnitId,
            tempVuId: tempVuData.TempVisualUnitId,
            name: tempEditName,
            description: tempVuData.Description,
            viewerType: tempVuData.ViewerType,
            preview: tempVuData.Preview,
            refreshInterval: tempVuData.RefreshInterval,
            vuDeId: -1,
            privacyLock: tempVuData.PrivacyLock,
            allowDrillThru: tempVuData.AllowDrillThru,
            measures: currentlist[0]?.measures,
            filterable: currentlist[0]?.filterable,
            dimensionRow: currentlist[0]?.dimensionRow,
            dimensionCol: currentlist[0]?.dimensionCol,
            dashboardName: 'Temp',
            IsEnabledAutoNavigation: tempVuData.IsEnabledAutoNavigation,
            refinementProfile: tempVuData.refinementProfile,
        };

        // Update local state immediately
        setreportName(tempEditName);

        // Exit edit mode before API call completes
        updateTempVuData('Name', tempEditName);

        callEditSaveVUAPI(reqVisualUnitData)
            .unwrap()
            .then((EditSaveVUResponse) => {
                if (EditSaveVUResponse && EditSaveVUResponse.vuDetails) {
                    setVu({
                        ...vu,
                        ...EditSaveVUResponse.vuDetails.data,
                    });
                }
                setEditingName(false);
                FoundationsGenericToaster("success", "Report Updated Successfully");
            })
            .catch((error) => {
                console.error('Error in callEditSaveVUAPI:', error);
                 FoundationsGenericToaster("error", "Report Update Failed");
            });
    }
     setEditingName(false);
};



    //logic
    const toggleEdit = () => {
        setIsExplore(!isExplore)
        if(isExplore){
            setIsOpenDrillThru(false)
            setActiveMeasure(-1)
        }
    }
    
    const handleRefresh = () => {
        setrendercomp(false)
        callExecuteSummary()
    }
    // const [SummaryReportAutoRefreshInterval, setSummaryReportAutoRefreshInterval] = useState<number>()

    // const SummaryReportContextValue = {
    //     SummaryReportAutoRefreshInterval,
    //     setSummaryReportAutoRefreshInterval
    // }
    const [callcheckEditSaveAPI] = useCheckEditSaveMutation()

    const toggleDialog = () => {
        if (actionType === "addNewVU" || actionType === "copyVU")
        {
            setiseditSettingsDialogOpen(!iseditSettingsDialogOpen)
        }
        else
        {
            setshouldcallCheckeditsave(true)
        }

    } 
        
    function getColumnClasses(): string[] {
        if (hasError) {
            if (longErrorMessage) {
                return ['col-sm-12', 'col-md-12', 'col-lg-12', 'col-xl-12']
            } else {
                return ['col-sm-12', 'col-md-6', 'col-lg-3', 'col-xl-3']
            }
        }

        if (noTargetMeasureList.length) {
            switch (targetMeasureList.length) {
                case 0:
                    if (noTargetMeasureList.length > 3) {
                        return ['col-sm-12', 'col-md-7', 'col-lg-5', 'col-xl-5']
                    }
                    return ['col-sm-12', 'col-md-6', 'col-lg-3', 'col-xl-3']
                case 1:
                    if (noTargetMeasureList.length > 3) {
                        return ['col-sm-12', 'col-md-8', 'col-lg-8', 'col-xl-6']
                    }
                    return ['col-sm-12', 'col-md-8', 'col-lg-6', 'col-xl-5']
                case 2:
                    return ['col-sm-12', 'col-md-12', 'col-lg-9', 'col-xl-7']
                case 3:
                    return ['col-sm-12', 'col-md-12', 'col-lg-12', 'col-xl-8']
                case 4:
                    return ['col-sm-12', 'col-md-12', 'col-lg-12', 'col-xl-9']
                default:
                    return ['col-sm-12', 'col-md-12', 'col-lg-12', 'col-xl-12']
            }
        } else {
            switch (targetMeasureList.length) {
                case 0:
                    return ['col-sm-12', 'col-md-6', 'col-lg-2', 'col-xl-2']
                case 1:
                    return ['col-sm-12', 'col-md-5', 'col-lg-3', 'col-xl-3']
                case 2:
                    return ['col-sm-12', 'col-md-6', 'col-lg-5', 'col-xl-4']
                case 3:
                    return ['col-sm-12', 'col-md-8', 'col-lg-6', 'col-xl-6']
                case 4:
                    return ['col-sm-12', 'col-md-12', 'col-lg-8', 'col-xl-8']
                case 5:
                    return ['col-sm-12', 'col-md-12', 'col-lg-10', 'col-xl-8']
                default:
                    return ['col-sm-12', 'col-md-12', 'col-lg-12', 'col-lg-12']
            }
        }
    }
    useEffect(() => {
        if (isUpdateFromSettings.current) {
            setrendercomp(false)
            callExecuteSummary();
            isUpdateFromSettings.current = false;
        }
    }, [tempVuData]);

    useEffect(() => {      
          
        if (actionType === 'copyVU') {
            toggleEdit();

            const lastIndex = reportListRef.current.length - 1;
            const lastReportRef = reportListRef.current[lastIndex];

            if (lastReportRef) {
                lastReportRef.scrollIntoView({ behavior: "smooth", block: "center" });

                const timer = setTimeout(() => {}, 2000);
                return () => clearTimeout(timer);
            }
        }
    }, [actionType])      
    

    const callExecuteSummary = (payload: any = null) => {
        var requVU: any = payload !== null ? payload : {}
        if (!payload) {
            if (tempVuData.ViewerType > FoundationsEnums.VisualUnitViewerType.SVU && tempVuData.ViewerType != FoundationsEnums.VisualUnitViewerType.WorkList) {
                requVU.WorkspaceId = tempVuData.DashBoardId
                requVU.VisualUnitId = tempVuData.VisualUnitId
                requVU.TempVisualUnitId = tempVuData.TempVisualUnitId
                    ? tempVuData.TempVisualUnitId
                    : -1
                requVU.viewerType = tempVuData.ViewerType
                requVU.ChartFilter = tempVuData.ChartFilter
                requVU.ChartSwitch = tempVuData.ChartSwitch
                requVU.ChartSettings = tempVuData.ChartSettings
                requVU.ViewerTypeChanged = tempVuData.ViewerTypeChanged
                requVU.ForceRefresh = tempVuData.ForceRefresh ? tempVuData.ForceRefresh : 0
                requVU.callerType = tempVuData?.callerType
                // engioneType does not exist on visual unit object
                // requVU.EngineType = tempVuData.engineType
            } else {
                requVU.WorkspaceId = tempVuData.DashBoardId
                requVU.VisualUnitId = tempVuData.VisualUnitId
                requVU.TempVisualUnitId = tempVuData.TempVisualUnitId
                requVU.PageSize = tempVuData.PageSize
                requVU.PageNumber = tempVuData.PageNumber
                requVU.SortColumn = tempVuData.SortColumn
                requVU.SortOrder = tempVuData.SortOrder
                requVU.ViewerTypeChanged = tempVuData.ViewerTypeChanged
                requVU.viewerType = tempVuData.ViewerType
                requVU.ForceRefresh = tempVuData.ForceRefresh ? tempVuData.ForceRefresh : 0
                requVU.TableSettings = tempVuData.TableSettings
                requVU.callerType = tempVuData?.callerType
                // requVU.EngineTyp = vuDetails.engineType
            }
        }

        callExecuteAPI(requVU)
            .then((response: any) => {
                const currentData = response.data?.data
                dispatch(SetVudata({ vuId: vuDetails.VisualUnitId, data: currentData }))
                const reportdata = currentData
                    ? currentData.ComputedData
                        ? JSON.parse(currentData.ComputedData)
                        : currentData.reportData
                            ? JSON.parse(currentData.reportData).ComputedData
                            : []
                    : []
                // setTempVuData({ ...currentData.vuDetails })
                updateTempVuData('TableSettings', currentData.tableSettings) //need this up-to date table settiings.
                updateTempVuData('AllowDrillThru',currentData.vuDetails.AllowDrillThru)
                updateTempVuData('Name',currentData.vuDetails.Name)
                updateTempVuData('PrivacyLock',currentData.vuDetails.PrivacyLock)
                if (!isExplore) {
                    setVu(currentData.vuDetails)
                }
                if (currentData.vuDetails.RefreshInterval > 0) {
                    setRefreshIntervalLabel()
                }
                props.setVuData(currentData.vuDetails)       
                if((isTable(currentData.vuDetails.ViewerType) || isChart(currentData.vuDetails.ViewerType))
                 || ((currentData.vuDetails.viewerType == FoundationsEnums.VisualUnitViewerType.SVU) &&
                (currentData.vuDetails?.XAxisList.length != 0 || currentData.vuDetails?.YAxisList.length != 0)))
                    {
                        let updatedVUList = currentWorkspaceData.VisualUnits.map(x => (x.VisualUnitId == tempVuData.VisualUnitId ? {...tempVuData} : {...x}));
                        bulkUpdateVUs(updatedVUList)
                    } 
                setMeasureObjects(reportdata)
                setreportName(currentData?.vuDetails?.Name)
                setrendercomp(true)
                setreportPrivacy(currentData?.vuDetails.PrivacyLock)
                setTargetMeasureList(
                    currentData.vuDetails.MeasureList
                        ?.map((measure: any, index: number) => ({
                            ...measure,
                            indexid: index, // Append the index as indexid
                        }))
                        .filter(
                            (measure: any) =>
                                measure.UserTarget.TargetType != 0 ||
                                measure.DefaultTarget.TargetType != 0
                        )
                )
                setNoTargetMeasureList(
                    currentData.vuDetails.MeasureList
                        ?.map((measure: any, index: number) => ({
                            ...measure,
                            indexid: index, // Append the index as indexid
                        }))
                        .filter(
                            (measure: any) =>
                                measure.UserTarget.TargetType == 0 &&
                                measure.DefaultTarget.TargetType == 0
                        )
                )
                setTargetlessMeasuresExist(
                    currentData.vuDetails.MeasureList?.filter(
                        (measure: any) =>
                            measure.UserTarget.TargetType == 0 &&
                            measure.DefaultTarget.TargetType == 0
                    ).length > 0
                )  
                  
                //setActiveMeasure(getFirstAllowedDrillThruIndex)  // This needs to be checked, as logic was migrated to React but Currently not helping while launching drill thrus
                setErrorText(currentData.errorMessage)
                sethasError(currentData.errorMessage != '')
                setLongErrorMessage(currentData.errorMessage.length > 300)
                setaddedToFavourite(currentData.vuDetails.AddedToFavourite)
            })
            .catch((e) => {
                console.error("Error handling and operationStatusMessage handling is missing")
            })
    }

    useEffect(() => {
        //FP- 11395 since we are not using trigger api from store, so keeping first render call, rest is removed...
        let actionsOpenPayload: IActionsOpenState = {
            isReportSettingOpen: false,
            isEditOpen: false,
            isActionOpen: false,
            isVuRefreshClicked: false,
        }
        dispatch(
            setReportActionsState({ vuId: vuDetails.VisualUnitId, actionsOpenPayload })
        )
        callExecuteSummary()
    }, [])


    useEffect(() => {
        if (isExplore) {
            callRunVisualUnitTableWithId(FoundationsEnums.VisualUnitViewerType.SVU, FoundationsConstants.enumVUCallerType.Explore, 1) //setIsExplore true is setting inside callRunVisualUnitTableWithId
        } else {
            setIsExplore(false)
        }
    }, [isExplore])

    useEffect(() => {
        if (isExplore) {
            callRunVisualUnitTableWithId(tempVuData.ViewerType, FoundationsConstants.enumVUCallerType.Explore, 0, 'editRefresh') //editRefresh- only reason to avoid again setting isExplore to true
        } else {
            SummaryrefreshVisualunit() 
        }
    }, [tempVuData.XAxisList, tempVuData.YAxisList, tempVuData.MeasureList, tempVuData.FilterableList])

    useEffect(() => {
        setcolumnClasses(getColumnClasses())
    }, [targetMeasureList, noTargetMeasureList, longErrorMessage, hasError])

    // open the worklist by default for worklist VU type
    useEffect(() => {
        if (
            executeResponse !== undefined && props.vuDetails.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkList ||
            props.vuDetails.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkListWithoutGauge
        ) {
            const measureIndex = activeMeasure >= 0 ? activeMeasure : getFirstAllowedDrillThruIndex()
            if (measureIndex >= 0) {
                openDrillThru(measureIndex)
                setIsOpenDrillThru(true)
            }
        } 
    },[executeResponse])
    // const summaryDrillthruprops = {

    // }
    const handleToggleDrillThru = (index: number, ) => {
        let prevIndex = activeMeasure
        let measureIndexVal = index
        if (prevIndex >= 0) {
            if (prevIndex === index) {
                setIsOpenDrillThru(false)
                setActiveMeasure(-1)
                callRunVisualUnitTableWithId(FoundationsEnums.VisualUnitViewerType.SVU, FoundationsConstants.enumVUCallerType.Default, 0)                                                    
            } else {
                openDrillThru(measureIndexVal) 
                setIsOpenDrillThru(true)
            }
        } else {
            openDrillThru(measureIndexVal) 
            setIsOpenDrillThru(true)
        }
    }



    const checkIfDrillThruAllowed = (measureIndex: number) => {
        if (measureIndex < 0) {
            measureIndex = 0
        }
        return vu.MeasureList[measureIndex]?.AllowDrillThru.toUpperCase() == 'Y'
    }

    const openDrillThruInExplore = useCallback(
        (cellInfo: any, cell: string) => {
            let initPaylod: IDrillThruPayloadState = { ...initialDrillThruPayload }
            initPaylod.drillThruDP = cellInfo
            initPaylod.vuId = vuDetails.VisualUnitId
            initPaylod.isSummaryReport = false
            initPaylod.cellId = cellInfo.cellId
            initPaylod.isAsync = true
            initPaylod.cellValue = cell
            initPaylod.dashBoardId = getWorkspaceIdFromStore
            initPaylod.drillThruActionType = 'dt_paginate'

            setExploreDrilThruPayload(initPaylod)
            setLaunchExploreDrillThru(true)
        },
        [initialDrillThruPayload, getWorkspaceIdFromStore]
    )

    const openDrillThru = (measureIndex: number, autoRefresh = false) => {
        let currentVUDetails = { ...tempVuData }
        if (
            // !vu.hasError &&
            vu.MeasureList[measureIndex] &&
            checkIfDrillThruAllowed(measureIndex)
        ) {
            setActiveMeasure(measureIndex)
            let parsedVUData = JSON.parse(executeResponse.data?.reportData)
            let currentMeasure = executeResponse.data.vuDetails.MeasureList[measureIndex]
            let measureVal = ''
            let measureVal1 = ''
            // if (measureIndex == currentMeasure.indexOf(currentMeasure[measureIndex])) {
            // }
            let arr: any[] = []
            if (parsedVUData?.ComputedData?.length > 0) {
                arr = parsedVUData?.ComputedData
            }
            arr.length > 0 &&
                arr.forEach((element) => {
                    if (arr.indexOf(element) != measureIndex)
                        measureVal1 +=
                            element.MeasureName + '  : ' + ' ' + element.DataPoint + ' &nbsp;  '
                })
            measureVal = currentMeasure[measureIndex]?.MeasureName || undefined

            let cellId = `${visualUnitId}_0_${measureIndex}`
            let cellVal = parsedVUData?.ComputedData[measureIndex]?.DataPoint

            let metaDataId = currentMeasure?.MetaDataId
            let DetailId = currentMeasure?.DetailId
            let MeasureName = parsedVUData?.ComputedData[measureIndex]?.MeasureName
            setMeasureName(MeasureName)

            let formedInitPayload = { ...initialDrillThruPayload }
            formedInitPayload.vuId = visualUnitId
            formedInitPayload.cellId = cellId
            formedInitPayload.cellValue = cellVal
            formedInitPayload.vudetails = tempVuData
            formedInitPayload.drillThruDP = {
                cellId: cellId,
                dimDPs: [],
                meId: metaDataId,
                vuDeId: DetailId,
            }
            formedInitPayload.isSummaryReport = true
            formedInitPayload.CurrentClickedMeasure = MeasureName
            formedInitPayload.IsEnabledAutoNavigation = true
            formedInitPayload.dashBoardId = props.DashBoardId
            formedInitPayload.drillThruSetId = currentMeasure?.DrillThruSetId
            formedInitPayload.MeasureListValue = measureVal1 || undefined
            formedInitPayload.pageSize = vu?.DrillthruPageSize || undefined
            //FIXME: Chetan, On 2nd measure click, payload does not form properly
            setDrillThruPayload((props: ITableDrillThru) => ({
                ...props,
                initialPayload: formedInitPayload,
            }))
            let oldViewType = tempVuData.ViewerType
            //vuDetails.viewerType = FoundationsEnums.VisualUnitViewerType.WorkList

            if (
                !editing &&
                (oldViewType !== FoundationsEnums.VisualUnitViewerType.WorkList ||
                    oldViewType !== FoundationsEnums.VisualUnitViewerType.WorkListWithoutGauge)
            ) {
                setNoExecute(true)
                if (autoRefresh) {
                    currentVUDetails.callerType = 'AutoRefresh'
                } else {
                    currentVUDetails.callerType = 'Refresh'
                }
                callRunVisualUnitTableWithId(FoundationsEnums.VisualUnitViewerType.WorkList, currentVUDetails.callerType, 0)
            }
        }
    }

    const [maxWidth, setMaxWidth] = useState<number | null>(0)
    const loadingBoxRef = useRef<HTMLDivElement | null>(null)
    const tableElementsRef = useRef<NodeListOf<HTMLDivElement> | null>(null)
    useEffect(() => {
        const checkVisibility = () => {
            // Check if loading box is hidden using ref
            if (loadingBoxRef.current && !loadingBoxRef.current.offsetParent) {
                let calculatedMaxWidth = 1300

                // Iterate over each table element using ref
                if (tableElementsRef.current) {
                    tableElementsRef.current.forEach((table) => {
                        const rect = table.getBoundingClientRect()
                        if (rect.width > calculatedMaxWidth) {
                            calculatedMaxWidth = rect.width
                        }
                    })
                }
                // Update the state with maxWidth
                setMaxWidth(calculatedMaxWidth)
            }
        }

        const intervalId = setInterval(checkVisibility, 200)

        // Cleanup interval when component unmounts
        return () => {
            clearInterval(intervalId)
        }
    }, []) // This effect runs once when the component mounts

    const markFavourite = () => {
        markVisualUnitFavorite(
            props.DashBoardId+"",
            visualUnitId,
            vuDetails.Name,
            addedToFavourite,
            callMarkVUfavouriteAPI as any
        )
        setaddedToFavourite(!addedToFavourite)
    }

    const handleVisibilityChange = (newVisibility: any) => {
        setIsVisible(newVisibility)
    }

    const SummaryrefreshVisualunit = async () => {
        try {
            const wsid = props.DashBoardId // Replace with actual WSID
            const Id = vuDetails.VisualUnitId // Replace with actual ID

            const response: any = executepayload({ wsid, Id }).unwrap()

            // Additional logic to handle success
            if (response) {
                const payload: postVUobj = {
                    WorkspaceId: tempVuData.DashBoardId,
                    VisualUnitId: tempVuData.VisualUnitId,
                    TempVisualUnitId:
                        tempVuData.TempVisualUnitId > 0 ? tempVuData.TempVisualUnitId : -1,
                    PageSize: 10000,
                    PageNumber: 1,
                    SortColumn: tempVuData.SortColumn,
                    SortOrder: tempVuData.SortOrder,
                    ViewerTypeChanged: false,
                    ViewerType: tempVuData.ViewerType,
                    ForceRefresh: tempVuData.ForceRefresh,
                    TableSettings: tempVuData.TableSettings || {}, // Ensure TableSettings is an object
                    callerType: 'Refresh',
                    EngineType: 'newengine',
                    // EngioneType does not exist on visual unit data
                    // vuDetails.EngineType == 'oldengine' && vuDetails.EngineType != undefined
                    //     ? 'oldengine'
                    //     : 'newengine',
                }
                callExecuteSummary(payload)
            }
        } catch (error) {
            console.error('Error refreshing visual unit:', error)
        }
    }

    const callRunVisualUnitTableWithId = (
        viewerType:number,
        callerType: string = FoundationsConstants.enumVUCallerType.Default,
        forceRefresh: number = 0,
        reasonForCall: string = ''
    ) => {
        let reqRunVUData: any = {
            visualUnitId: vuDetails.VisualUnitId,
            dashBoardId: props.DashBoardId,
            callerType: callerType,
            pageSize: 10000,
            pageNumber: 1,
            sortColumn: '',
            sortOrder: '',
            forceRefresh: forceRefresh,
            viewerTypeChanged: true,
            EngineType: 'newengine',
            viewerType: viewerType,
            tempVisualUnitId: -1,
            grandTotal: true,
            privacyLock: reportPrivacy,
            BuildQuery: false,
            isAsync: true
        }
        reqRunVUData.tableSettings = tempVuData.TableSettings
        reqRunVUData.viewerTypeChanged = viewerType !== tempVuData.ViewerType
        reqRunVUData.tempVisualUnitId = tempVuData.TempVisualUnitId

        callExecuteTableAPI(reqRunVUData)
            .unwrap()
            .then((response: IVUconfigResponse) => {
                let resultData = response.data
                if (!resultData.reportData) {
                    setOperationStatusMessage("No data found")
                    return
                }
                const vuDataObj = {
                    drillThruDpList: resultData.drillThruDPList,
                    vuDetails: resultData?.vuDetails,
                    execTableRespData: resultData,
                }
                setTempVuData({
                    ...tempVuData,
                    ChartSwitch: resultData.chartSwitch,
                    ChartSettings: resultData.chartSettings,
                    TableSettings: resultData.tableSettings,
                    ViewerType: resultData.viewerType,
                })
                VUdataObjRef.current = vuDataObj
                setExecTableRespData(resultData)
                let tempTableJsonData = resultData.reportData !== undefined
                    ? JSON.parse(resultData.reportData)?.ComputedData
                    : { Content: [], Headers: [] } //easy to debug that's why its added.

                setTableJSOnData(tempTableJsonData)

                setReportFailed(false)
                setRedrawReport(!redrawReport)
                callerType === FoundationsConstants.enumVUCallerType.Explore && setIsExplore(true)
            }).catch(err => { setReportFailed(true); console.error("run visual unit table failure") })
    }

    //grid-stack-item d-flex flex-column
    const toggleSidebar = () => {
        settoggleExpColDrillThru((prev) => !prev)
    }

    const fetchBPthenshowKmi = (latestClickedMeausre : number) => {
        const measureList = vuDetails.MeasureList[latestClickedMeausre];
        const dataTypeString = measureList.SingleValueReportId > 0 ? measureList.SingleValueReport.MeasureList[0].MetaData.DataType.toString() : measureList.MetaData.DataType.toString()

        callGetBusinessParams({ datatype: dataTypeString })
            .unwrap()
            .then((response: any) => {
                setBusinessparameterList(response.data.BusinessParametersList)
                setshowKmi(true)
            })
            .catch((error: any) => {
                console.error("Error fetching Business Parameter List:", error)
            })
    }

    // ========================================== Auto Refresh Code ==========================================
    const intervalRef: any = useRef(null)
    const lastRefreshedRef = useRef(Date.now()); // Track last refresh time with ref
    const [lastRefreshedStatus, setLastRefreshedStatus] = useState<any>(null)
    const displayTimeDifferenceForSummary = (dateObj: any) => {
        let timeDifferenceInSeconds = Math.floor((Date.now() - dateObj) / 1000)

        if (timeDifferenceInSeconds < 60) {
            return 'Just now'
        } else if (timeDifferenceInSeconds < 3600) {
            return (
                Math.floor(timeDifferenceInSeconds / 60) +
                (timeDifferenceInSeconds / 60 > 1 ? ' mins' : ' min')
            )
        } else if (timeDifferenceInSeconds < 864000) {
            return (
                Math.floor(timeDifferenceInSeconds / 3600) +
                (timeDifferenceInSeconds / 3600 > 1 ? ' hrs' : ' hr')
            )
        } else {
            return (
                Math.floor(timeDifferenceInSeconds / 86400) +
                (timeDifferenceInSeconds / 86400 > 1 ? ' days' : ' day')
            )
        }
    }
    const updateLastRefreshedTimeForSummary = (dateObj: any) => {
        const minutesDifference: string = displayTimeDifferenceForSummary(dateObj)
        setLastRefreshedStatus(minutesDifference)
    }

    const setRefreshIntervalLabel = () => {
        const refreshInterval = vu.RefreshInterval;

        if (refreshInterval !== 0) {
            if (intervalRef.current) clearInterval(intervalRef.current); // Clear any existing intervals

            // Set the initial status immediately
            lastRefreshedRef.current = Date.now();
            updateLastRefreshedTimeForSummary(lastRefreshedRef.current);


            // Set up interval to update UI every minute and check if it’s time to refresh
            intervalRef.current = setInterval(() => {
                const timeSinceLastRefresh = Math.floor((Date.now() - lastRefreshedRef.current) / 1000);

                if (timeSinceLastRefresh >= refreshInterval * 60) {
                    lastRefreshedRef.current = Date.now(); // Directly update ref value
                    updateLastRefreshedTimeForSummary(lastRefreshedRef.current);
                } else {
                    updateLastRefreshedTimeForSummary(lastRefreshedRef.current);
                }
            }, 60000); // Run every minute
        }

        // Cleanup on unmount
        return () => {
            if (intervalRef.current !== undefined) {
                clearInterval(intervalRef.current);
            }
        };
    }

    // ========================================== End Auto Refresh Code ==========================================
    const [isFlashing, setIsFlashing] = useState(false);

    const handleCopy = () => {
        setIsFlashing(true);
        setTimeout(() => setIsFlashing(false), 1000);
    };

    return (
        <>
         {/* <SummaryReportContext.Provider value={SummaryReportContextValue}> */}
            {isVisible && (
            <span id={`new_vus_${visualUnitId}`} className="vu-container">
                <div
                    className={`grid-stack-item ${columnClasses[0]} ${columnClasses[1]} ${columnClasses[2]} ${columnClasses[3]} ${targetMeasureList?.length == 0 ? 'targetless-summary' : ''
                        } ${isOpenDrillThru || isExplore ? 'worklist-display' : ''}`}
                    id={`summary_vus_${visualUnitId}`}
                    style={{ height: 'auto' }}
                >
                    <span className="summary_vu_title_container">
                        <h3 data-hasqtip="12">
                    {editingName ? (
                        <span className="edit-visual-unit-name">
                        <input
                            id={`edit_visual_unit_name_${visualUnitId}`}
                            type="text"
                            value={tempEditName}
                            onChange={(e) => setTempEditName(e.target.value)}
                            onBlur={() => {
                                handleUpdateVUName();
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleUpdateVUName();
                                } else if (e.key === 'Escape') {
                                    setTempEditName(vuDetails.Name) //revert to original name
                                    setEditingName(false);
                                }
                            }}
                            autoFocus
                            maxLength={100}
                        />
                        </span>
                    ) : (
                        <span
                            className="visual-unit-name d-inline-block"
                            onDoubleClick={() => {
                                setTempEditName(reportname); // Initialize temp state with current name
                                setEditingName(true);
                             }}
                        >
                            {reportname}
                        </span>
                    )}
                        <span className='mr-1'>
                            <DetailedTooltip
                                key={'summary_vu_tooltip_info_link_' + tempVuData.VisualUnitId}
                                content={getToolTipContent(tempVuData, isAdmin, executeResponse?.data?.sqlString, isFlashing)}
                                placement="bottom"
                                animation="shift-away-subtle"
                                isCopyable={isAdmin}
                                copyText={executeResponse?.data?.sqlString}
                                onCopy={handleCopy}
                                allowHTML={true}
                                showIcon={true}
                                icon={<>ⓘ</>}
                                trigger={'mouseenter focus'}
                                delay={[100, 0]}
                            ></DetailedTooltip>
                            </span>
                            <a
                                id={'buttonFavVUSaveChanges_' + visualUnitId}
                                className="FavVUbutton mr-1"
                            >
                                <i
                                    className={`feather ${addedToFavourite ? 'icon-star-on shine' : 'icon-star'} cursor-pointer favIndivualGuageSummary-star-icon m-1`}
                                    id={'button_FavVUSaveChanges_' + visualUnitId}
                                    onClick={() => markFavourite()}
                                ></i>
                            </a>
                            {
                                (tempVuData.AppGUID=== '') && (currentUserData.privileges?.includes('VisualUnit_Update')) &&
                                (
                                    <span
                                        title="Change report name and description"
                                        className="link_rename_vu feather icon-settings"
                                        onClick={() => setiseditSettingsDialogOpen(true)}
                                    ></span>
                                )
                            }
                            <span className="ajax-loading-box hide">
                                <span className="ajax-loading-image"></span>Loading...
                            </span>
                        </h3>
                            {/* Dialog component */}
                                <VuSettings
                                    isExplore={isExplore}
                                    setisExplore={setIsExplore}
                                    report={vu}
                                    iseditSettingsDialogOpen={iseditSettingsDialogOpen}
                                    setiseditSettingsDialogOpen={setiseditSettingsDialogOpen}
                                    workspaceId={props.DashBoardId}
                                    drillThruDPList={drillThruDPList}
                                    vuParams={vuParams}
                                    setReport={setVu}
                                    setTempVuData={setTempVuData}
                                    isUpdateFromSettings={isUpdateFromSettings}
                                    isSaveClicked={isSaveClicked}
                                    saveVUdataChanges={saveVUdataChanges}
                                    setsaveVUdataChanges={setsaveVUdataChanges}
                                    shouldcallCheckeditsave={shouldcallCheckeditsave}
                                    setupVU={setupVU}
                                />
                            
                    </span>
                    {!isExplore &&(
                    <span style={{ float: 'right' }}>
                        <span
                            id={`Dashboard_Message_${visualUnitId}`}
                            className="dashboard-vu-message"
                        ></span>
                        {!isExplore && (
                            <ReportActions
                                dashboardId={props.DashBoardId}
                                refreshVisualUnit={SummaryrefreshVisualunit}
                                snapshotCount={0}
                                tempVuData={{ ...tempVuData, DashBoardId: props.DashBoardId }}
                                isSummary={true}
                                isblockDisplay={false}
                                onVisibilityChange={handleVisibilityChange}
                                IsVUExistAsSingleValueReport={executeResponse?.data?.IsVUExistAsSingleValueReport}
                                OperationStatusMessage={operationStatusMessage}
                                isDrillThruLaunched={isOpenDrillThru}
                                toggleIsExplore={toggleEdit}
                                setremoveFromWorkspace={props.setremoveFromWorkspace}
                                />
                            )}
                        </span>)}
                    <div
                        className={isOpenDrillThru ? 'row' : ''}
                        style={
                            isOpenDrillThru
                                ? { margin: '.5rem 0', width: '100%' }
                                : { marginTop: '35px' }
                        }
                    >
                        <div
                            id={`error_message_${visualUnitId}`}
                            className="individual_summary_gauge_block mb-3"
                            style={{ display: hasError ? 'block' : 'none' }}
                        >
                            <div
                                style={{
                                    textAlign: longErrorMessage ? 'left' : 'center',
                                    maxWidth: longErrorMessage ? '100%' : '20rem',
                                    margin: 'auto',
                                    padding: '0 1rem 0.5rem',
                                    fontSize: '14px',
                                }}
                            >
                                {errorText}
                            </div>
                        </div>
                        {!hasError && (
                            <>
                                <div
                                    id={`gauge_summary_block_${visualUnitId}`}
                                    className={`individual_summary_gauge_block ${isOpenDrillThru || isExplore
                                        ? targetlessMeasuresExist
                                            ? 'pr-4'
                                            : 'pr-0'
                                        : ''
                                        } pl-0`}
                                    style={{
                                        maxWidth: showWorklist ? '300px' : undefined,
                                        display:
                                            hasError || toggleExpColDrillThru || isExplore
                                                ? 'none'
                                                : undefined,
                                    }}
                                >
                                    {targetMeasureList?.map(
                                        (measure: {
                                            AllowDrillThru?: any
                                            UserTargetId: number
                                            UserTarget: {
                                                TargetType: number
                                                TargetValue: string
                                                TargetInputType: number
                                            }
                                            DefaultTarget: {
                                                TargetType: number
                                                TargetValue: string
                                                TargetInputType: number
                                            }
                                            SingleValueReportId: number
                                            SingleValueReport: {
                                                MeasureList: { MetaData: { DataType: any } }[]
                                            }
                                            MetaData: { DataType: any }
                                            indexid: number
                                        }) => (
                                            <span className="measure_gauge" key={measure.indexid}>
                                                <div
                                                    id={`new_summary_${visualUnitId}_${measure.indexid}`}
                                                    className={`gauge-container measure-container ${measure.AllowDrillThru === 'Y'
                                                        ? 'cursor-pointer'
                                                        : ''
                                                        } ${isOpenDrillThru &&
                                                            measure.indexid === activeMeasure
                                                            ? 'active'
                                                            : ''
                                                        } ${measure.AllowDrillThru === 'N' ? 'noDrillThru' : ''}`}
                                                    data-name={measure.indexid}
                                                    title={`${measureObjects[measure.indexid]?.MeasureName}`}
                                                    onClick={() => {
                                                        if (measure.AllowDrillThru !== 'Y') {
                                                            return // Skip further execution if not allowed
                                                        }

                                                            handleToggleDrillThru(measure.indexid)
                                                      
                                                    }}
                                                >
                                                    {measureObjects.length > 0 && rendercomp ? (
                                                        <>
                                                            <SummaryGauge
                                                                measure={measure}
                                                                measureObject={
                                                                    measureObjects[measure.indexid]
                                                                }
                                                                vuId={visualUnitId}
                                                                index={measure.indexid}
                                                                showKmi={(index: number) => {
                                                                    setcurrenClickedMeausre(
                                                                        measure.indexid
                                                                    ),
                                                                    fetchBPthenshowKmi(measure.indexid)
                                                                }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <LoaderBox loadingBoxRef={loadingBoxRef} />
                                                        </>
                                                    )}
                                                </div>
                                            </span>
                                        )
                                    )}


                                    <span
                                        className="summaryTableWrapper"
                                        style={{
                                            display: targetlessMeasuresExist
                                                ? undefined
                                                : 'none',
                                        }}
                                    >
                                        <table className="table table-hover">
                                            <tbody id={`measure_table_body_${visualUnitId}`}>
                                                {noTargetMeasureList?.map((measure: any) => (
                                                    <tr
                                                        key={measure.indexid}
                                                        className={`measure-container ${measure.AllowDrillThru === 'Y'
                                                            ? 'cursor-pointer'
                                                            : ''
                                                            } ${isOpenDrillThru &&
                                                                measure.indexid === activeMeasure
                                                                ? 'active'
                                                                : ''
                                                            } ${measure.AllowDrillThru === 'N' ? 'noDrillThru' : ''}`}
                                                        id={`new_summary_${visualUnitId}_${measure.indexid}`}
                                                        data-name={measure.indexid}
                                                        title={`${measureObjects[measure.indexid]?.MeasureName}` || ''}
                                                        onClick={() => {
                                                            if (
                                                                measure.AllowDrillThru !== 'Y'
                                                            ) {
                                                                return // Skip further execution if not allowed
                                                            }
                                                            
                                                                handleToggleDrillThru(
                                                                    measure.indexid
                                                                )
                                                          
                                                        }}
                                                    >
                                                        <td>
                                                            <b
                                                                id={`label_${visualUnitId}_0_${measure.indexid}`}
                                                            >
                                                                {rendercomp ?
                                                                    (<span>
                                                                        {
                                                                            measureObjects[
                                                                                measure.indexid
                                                                            ]?.MeasureName
                                                                        }
                                                                    </span>
                                                                    ) : (
                                                                        <LoaderBox loadingBoxRef={loadingBoxRef} />)
                                                                }
                                                            </b>
                                                            {rendercomp ? (':') : ('')}
                                                        </td>

                                                        <td
                                                            id={`td__${visualUnitId}_0_${measure.indexid}`}
                                                            className="measureValue"
                                                        >
                                                            {rendercomp ?
                                                                (
                                                                    <span>
                                                                        {measureObjects[measure.indexid]
                                                                            ?.DataPoint}
                                                                    </span>

                                                                ) : (<LoaderBox loadingBoxRef={loadingBoxRef} />)}
                                                        </td>
                                                        <td>                                                      
                                                            {measure.BusinessParameter == null && (
                                                                <span
                                                                className="edit_measure edit_measure_target cursor-pointer"
                                                                id={measure.indexid.toString()}
                                                                onClick={(e: any) => {
                                                                    if (rendercomp) {
                                                                    setcurrenClickedMeausre(e.target.id),
                                                                    e.stopPropagation()
                                                                    fetchBPthenshowKmi(e.target.id)
                                                                    } 
                                                                }}
                                                                >
                                                                {rendercomp ? 'Add target' : 'Edit'}
                                                                </span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {targetMeasureList.length === 0 && (
                                            <div
                                                className="text-muted"
                                                style={{ fontSize: '12px', marginTop: '.1rem' }}
                                            >
                                                No Targets Set
                                            </div>
                                        )}
                                    </span>

                                </div>

                                <span
                                    id={`drillthru_block_${visualUnitId}`}
                                    className={
                                        isOpenDrillThru || isExplore
                                            ? 'pl-4 drillthru_block'
                                            : 'hide'
                                    }
                                    style={
                                        isOpenDrillThru || isExplore
                                            ? {
                                                overflowX: 'auto',
                                                width: '100%',
                                                padding: '10px',
                                                marginBottom: '1%',
                                            }
                                            : {}
                                    }
                                >

                                    {(isOpenDrillThru || isExplore) && (
                                        <>
                                            {isSummaryDrillThruLoading && (
                                                <div 
                                                    id={`React_drillthruLoading_${visualUnitId}`} 
                                                    style={{ width: '100%' }}
                                                    className='d-flex justify-content-center align-items-center'   
                                                >
                                                    <div
                                                        id={`React_ajax-loading-box-${visualUnitId}`}
                                                        className="ajax-loading-box"
                                                        style={{margin: '0px', textAlign: 'center'}}
                                                    >
                                                        <span className="ajax-loading-image"></span>Loading...
                                                    </div>
                                                </div>
                                            )}
                                            {!isSummaryDrillThruLoading && !isExplore && (
                                                <div
                                                    id={`toggleSideBarHandle_${visualUnitId}`}
                                                    className="expanded toggleSideBarHandle"
                                                    title={
                                                        toggleExpColDrillThru
                                                            ? 'Collapse'
                                                            : 'Expand'
                                                    }
                                                    style={{ display: 'flex', cursor: 'pointer' }}
                                                    onClick={toggleSidebar}
                                                >
                                                    <i
                                                        className={`collapse-worklist feather ${toggleExpColDrillThru
                                                            ? 'icon-chevron-right'
                                                            : 'icon-chevron-left'
                                                            }`}
                                                        id={`toggleSideBarHandleArrow_${visualUnitId}`}
                                                    ></i>
                                                </div>
                                            )}
                                            <div
                                                id={`gauge_worklist_block_${visualUnitId}`}
                                                className="individual_worklist_gauge_block"
                                                style={{
                                                    float: 'right',
                                                    width: '98%',
                                                    marginBottom: '35px',
                                                }}
                                            >
                                                <div
                                                    id={`dashboard_vu_${visualUnitId}`}
                                                    style={{
                                                        display: 'inline-block',
                                                        width: '100%',
                                                    }}
                                                >
                                                    <table
                                                        id={`vu_table_DrillThru_${visualUnitId}`}
                                                        className="vu-table-svu"
                                                    >
                                                        <tbody>
                                                            <tr></tr>
                                                        </tbody>
                                                        {isOpenDrillThru && !isExplore && executeResponse!=undefined ? (
                                                            <DrillThru
                                                                closeDrillThru={() =>
                                                                    {
                                                                        setIsOpenDrillThru(false)
                                                                        setActiveMeasure(-1)
                                                                        callRunVisualUnitTableWithId(tempVuData.ViewerType, FoundationsConstants.enumVUCallerType.Default, 0)
                                                                    }
                                                                }
                                                                onLoadComplete={handleLoadComplete}
                                                                executeResultData={JSON.parse(
                                                                    executeResponse?.data?.reportData
                                                                )}
                                                                isEnabledAutoNavigation={
                                                                    vu?.IsEnabledAutoNavigation
                                                                } //as of now
                                                                dashBoardId={props.DashBoardId}
                                                                reportData={{ id: visualUnitId }}
                                                                // CurrentClickedMeasure= {measureName}
                                                                inline={true}
                                                                initialPayload={
                                                                    drillThruPayload.initialPayload
                                                                }
                                                                // measureIndex={drillThruPayload.inline} //FIXME:
                                                                measureName={measureName} //FIXME:
                                                                // isautoRefresh={drillThruPayload.isAutoRefresh} //FIXME:
                                                                dataExplore={
                                                                    drillThruPayload.dataExplore
                                                                } //FIXME:
                                                                autoRefreshInterval={
                                                                    tempVuData.RefreshInterval
                                                                } //FIXME:
                                                                data_is_summary={true}
                                                                actionMode={
                                                                    drillThruPayload.actionMode
                                                                }
                                                                // vuDataObj={vuDetailsObj} //FIXME:
                                                                engineType={
                                                                    drillThruPayload.engineType
                                                                } //FIXME:
                                                                ViewerType={
                                                                    drillThruPayload.ViewerType
                                                                } //FIXME:
                                                            />
                                                        ) : (
                                                            isExplore && (
                                                                <div
                                                                    id={
                                                                        'vu_summary_view_params_' +
                                                                        visualUnitId
                                                                    }
                                                                    className="dashboard-vu-params"
                                                                    style={{ display: 'block' }}
                                                                >
                                                                    <div ref={setReportRef}>
                                                                    <DashboardVUParams
                                                                            onEditSave={toggleDialog}
                                                                            dashboardId={props.DashBoardId}
                                                                            tempVuData={tempVuData}
                                                                            setTempVuData={setTempVuData}
                                                                            setIsExplore={setIsExplore} 
                                                                            onVisibilityChange={setIsVisible}
                                                                            refreshVisualUnit={SummaryrefreshVisualunit}
                                                                            operationStatusMessage={operationStatusMessage}
                                                                            operationMode={actionType}
                                                                            setOperationStatusMessage={setOperationStatusMessage}    
                                                                        /> 
                                                                 </div>                                                        
                                                                    {isExplore && !launchExploreDrillThru ? (
                                                                        <ReportEl
                                                                            chartComponent={undefined}
                                                                            tempVuData={tempVuData}
                                                                            executeResult={VUdataObjRef.current
                                                                                .execTableRespData}
                                                                            isCollapsed={false}
                                                                            reportFailed={reportFailed}
                                                                            redrawReport={redrawReport}
                                                                            openDrillThru={openDrillThruInExplore}
                                                                            tableJSOnData={tableJSOnData}
                                                                            setTableJSOnData={setTableJSOnData}
                                                                            operationStatusMessage={operationStatusMessage}
                                                                            isExplore={isExplore}
                                                                            toggleIsExplore={()=>setIsExplore(!isExplore)} 
                                                                        />
                                                                    ) : launchExploreDrillThru && isExplore && (
                                                                        <DrillThru
                                                                            reportData={{
                                                                                id: vuDetails.VisualUnitId,
                                                                            }}
                                                                            closeDrillThru={() =>
                                                                                {
                                                                                    setLaunchExploreDrillThru(false)
                                                                                    callRunVisualUnitTableWithId(tempVuData.ViewerType, FoundationsConstants.enumVUCallerType.Default, 0)
                                                                                }
                                                                            }
                                                                            initialPayload={exploreDrilThruPayload}
                                                                            executeResultData={
                                                                                execTableRespData
                                                                            }
                                                                            dashBoardId={
                                                                                props.DashBoardId
                                                                            }
                                                                            isEnabledAutoNavigation={
                                                                                false
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                            )
                                                        )}
                                                    </table>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </span>
                            </>
                        )}
                    </div>

                    {vu.RefreshInterval !== 0 && !isExplore && (
                        <div
                            id={`last-refreshed-time_${visualUnitId}`}
                            className="feather icon-refresh-ccw last-refreshed-label"
                            title="This is an auto-refreshing report"
                        >
                            {'  ' + lastRefreshedStatus == null ? '' : lastRefreshedStatus}
                        </div>
                    )}

                    {showKmi && (
                        <div id="vu_rubric_dialog_wrapper" className="">
                            <TargetRubric
                                vuId={visualUnitId}
                                executeResult={executeResponse.data}
                                measureIndex1={currenClickedMeausre}
                                vuDetails={tempVuData}
                                isAutoRefresh={vu.RefreshInterval > 0}
                                closeKMI={closeKMI}
                                refreshReport={handleRefresh}
                                dashboardId={props.DashBoardId}
                                BusinessParamsList={BusinessParamsList}
                            />
                        </div>
                    )}
                </div>
            </span>
            )}
         {/* </SummaryReportContext.Provider> */}
        </>
    )
}

export default IndividualSummary
